﻿export function setPosition(clientX, clientY) {
    var element = document.getElementsByClassName('flyout-menu dropdown-menu position-absolute show')[0];
    if (element == null) {
        return;
    }
    element.style.setProperty('--mouse-x', clientX + 'px');
    element.style.setProperty('--mouse-y', clientY + 'px');
}